var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowElementsOnSummaryBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.51 18.3877C10.7216 18.3877 7.85004 15.7429 6.60571 13.9948C8.18253 11.8285 11.0188 9.61693 14.4949 9.61693C18.2833 9.61693 21.1548 12.2618 22.3941 14.0099C20.8173 16.1711 17.981 18.3877 14.505 18.3877M23.4218 13.7278C22.1876 11.8285 18.913 8.60938 14.4949 8.60938C10.4848 8.60938 7.26062 11.2341 5.58304 13.6875C5.51251 13.7882 5.49236 13.9041 5.50243 14.02C5.50243 14.1106 5.52258 14.1963 5.57296 14.2769C6.81226 16.1761 10.0868 19.3953 14.505 19.3953C18.5201 19.3953 21.7392 16.7706 23.4168 14.3172C23.4873 14.2114 23.5075 14.0955 23.4974 13.9797C23.4974 13.894 23.4722 13.8084 23.4218 13.7278Z",
    fill: "#0076A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4495 15.9464C13.3815 15.9464 12.51 15.0748 12.51 14.0068C12.51 12.9388 13.3815 12.0673 14.4495 12.0673C15.5176 12.0673 16.3891 12.9388 16.3891 14.0068C16.3891 15.0748 15.5176 15.9464 14.4495 15.9464ZM14.4495 11.0547C12.8223 11.0547 11.5024 12.3796 11.5024 14.0018C11.5024 15.624 12.8223 16.9489 14.4495 16.9489C16.0767 16.9489 17.3966 15.629 17.3966 14.0018C17.3966 12.3746 16.0767 11.0547 14.4495 11.0547Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowElementsOnSummaryBar);
export default __webpack_public_path__ + "static/media/show-elements-on-summary-bar.21b3844f2b6ef38d16cf4d4627d92632.svg";
export { ForwardRef as ReactComponent };